
// import React from "react";

// const BoxComponent = ({
//   value,
//   label,
//   cardBg,
//   icon,
//   className = "",
// }) => {
//   return (
//     <div
//       className={`flex items-center justify-between p-4 rounded-xl shadow-sm ${className}`}
//       style={{ backgroundColor: cardBg }}
//     >
//       <div className="flex flex-col">
//         <span className="text-lg  text-[#000000] font-semibold leading-none">{value}</span>
//         <span className="text-xs text-gray-600 mt-1">{label}</span>
//       </div>

//       <div className="ml-4 w-14 h-14 rounded-md flex items-center justify-center">
//         <img src={icon} alt={label} className="w-10 h-10 object-contain" />
//       </div>
//     </div>
//   );
// };

// export default BoxComponent;


import React from "react";
import { Box } from "lucide-react"; 
const BoxComponent = ({
  value,
  label,
  cardBg,
    iconColor = "#404040",  
  iconBg = "#fff",        
  icon,
  className = "",
}) => {
  return (
    <div
      className={`flex items-center justify-between p-4 rounded-xl shadow-sm border border-gray-300 ${className}`}
      style={{ backgroundColor: cardBg }}
    >
      <div className="flex flex-col">
        <span className="text-[24px] text-[#404040;] font-semibold leading-none">{value}</span>
        <span className="text-[12px] text-[#000] mt-1">{label}</span>
      </div>

      {/* <div className="ml-4 w-14 h-14 rounded-md flex items-center justify-center">
        <img src={icon} alt={label} className="w-[40px] h-[70px] " />
      </div> */}
     <div
        className="ml-4 w-[65px] h-[65px] flex items-center justify-center rounded-md"
        style={{ backgroundColor: iconBg }}
      >
        <Box  size={32} color={iconColor} />
      </div>
    </div>
  );
};

export default BoxComponent;
